export enum MittEvents {
  AUDIO_VOLUME = 'audio_volume',
  AUDIO_MUTE = 'audio_mute',
  TOUR_AUDIO_PLAY = 'tour_audio_play',
}
